import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Necesito saber de cocina o de nutrición?',
    a: 'Para nada. Está diseñado para principiantes absolutos. Cada receta te dice exactamente qué poner, cuánto y a qué temperatura. Si sabés apretar un botón en el Air Fryer, podés hacerlo.'
  }, {
    q: '¿Consigo los ingredientes en cualquier súper de Argentina?',
    a: 'Sí. Todas las recetas usan ingredientes que encontrás en cualquier súper, o tu almacén del barrio.'
  }, {
    q: '¿Sirve si tengo diabetes o problemas de inflamación?',
    a: 'La alimentación keto es conocida por ayudar a controlar los niveles de azúcar en sangre y reducir la inflamación intestinal. Siempre recomendamos consultarlo con tu médico, pero muchas personas reportan mejoras significativas.'
  }, {
    q: '¿Cuánto tiempo lleva preparar cada receta?',
    a: 'Menos de 20 minutos. La mayoría requiere 5 minutos de preparación y 10-15 minutos en el Air Fryer. Mientras cocina, vos hacés lo tuyo.'
  }, {
    q: '¿Cómo lo recibo?',
    a: 'Apenas pagás, recibís el link de descarga en tu email. Son archivos PDF que podés ver desde el celular, la tablet o la compu. También incluye versión para imprimir.'
  }, {
    q: '¿Ya probé dietas y siempre las dejo, por qué esta sería diferente?',
    a: 'Porque esta vez tenés un plan concreto de 14 días con las comidas resueltas, recetas que se hacen en minutos y comida que es rica de verdad. Cuando la dieta no es un sacrificio, la sostenés.'
  }];
  return <section className="bg-[#F5F5F5] py-16 px-4 md:py-24" data-id="element-62">
      <div className="max-w-[800px] mx-auto" data-id="element-63">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-heading font-bold text-2xl md:text-3xl text-gray-900 text-center mb-10" data-id="element-64">
          Preguntas Frecuentes
        </motion.h2>

        <div className="space-y-4" data-id="element-65">
          {faqs.map((faq, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100" data-id="element-66">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-5 text-left focus:outline-none" data-id="element-67">
                <span className="font-bold text-gray-900 pr-4" data-id="element-68">{faq.q}</span>
                <div className={`flex-shrink-0 w-8 h-8 rounded-full border-2 border-[#00A86B] flex items-center justify-center transition-transform duration-300 ${openIndex === idx ? 'rotate-180 bg-[#00A86B]' : 'bg-transparent'}`} data-id="element-69">
                  <ChevronDownIcon className={`w-5 h-5 ${openIndex === idx ? 'text-white' : 'text-[#00A86B]'}`} data-id="element-70" />
                </div>
              </button>

              <AnimatePresence data-id="element-71">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-72">
                    <div className="p-5 pt-0 text-gray-600 text-sm md:text-base leading-relaxed border-t border-gray-50" data-id="element-73">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}